import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ContentLoaderModule } from '@ngneat/content-loader';

@Component({
  selector: 'wilson-timeline-content-loader',
  templateUrl: './timeline-content-loader.component.html',
  styleUrls: ['./timeline-content-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContentLoaderModule],
})
export class TimelineContentLoaderComponent {}
